import * as React from 'react'
import { Route, Redirect, IndexRedirect } from 'react-router'
import { Dashboard } from './containers/Dashboard'
import { DashboardHome } from './containers/Dashboard/DashboardHome'
import { DashboardSettingsRoot } from './containers/Dashboard/DashboardSettings'
import { General } from './containers/Dashboard/DashboardSettings/General'
import { Locations } from './containers/Dashboard/DashboardSettings/Locations'
import { POSDevices } from './containers/Dashboard/DashboardSettings/POSDevices'
import { TaxSettings } from './containers/Dashboard/DashboardSettings/TaxSettings'
import { EcommerceSettings } from './containers/Dashboard/DashboardSettings/EcommerceSettings'
import { DigitalSignageSettings } from './containers/Dashboard/DashboardSettings/DigitalSignage'
import { DashboardProducts } from './containers/Dashboard/DashboardProducts'
import { ProductListing } from './containers/Dashboard/DashboardProducts/ProductListing'
import { ProductCategories } from './containers/Dashboard/DashboardProducts/ProductCategories'
import { PricingGroups } from './containers/Dashboard/DashboardProducts/PricingGroups'
import { Discounts } from './containers/Dashboard/DashboardProducts/Discounts/Discounts'
import { AddDiscount } from './containers/Dashboard/DashboardProducts/Discounts/AddDiscount'
import { DashboardInventory } from './containers/Dashboard/DashboardInventory'
import { DashboardViewInventory } from './containers/Dashboard/DashboardInventory/View'
import { InventorySnapshots } from './containers/Dashboard/DashboardInventory/View/InventorySnapshots'
import { ViewInventorySnapshot } from './containers/Dashboard/DashboardInventory/View/InventorySnapshots/ViewInventorySnapshot'
import { DashboardTransfer } from './containers/Dashboard/DashboardInventory/BulkTransfer/EditTransfer/DashboardTransfer'
import { Conversion } from './containers/Dashboard/DashboardInventory/Conversion'
import { Audit } from './containers/Dashboard/DashboardInventory/AuditV2'
import { StockAlerts } from './containers/Dashboard/DashboardInventory/StockAlerts'
import { DashboardCustomers } from './containers/Dashboard/DashboardCustomersV2'
import { Loyalty } from './containers/Dashboard/Loyalty'
import { LoyaltyContainer } from './containers/Dashboard/DashboardSettings/Loyalty'
import { SalesList } from './containers/Dashboard/DashboardPayments/SalesList'
import { ParkedSales } from './containers/Dashboard/DashboardPayments/ParkedSales'
import { DashboardInvoices } from './containers/Dashboard/DashboardInvoices'

import { PrintInvoice } from './containers/Dashboard/DashboardInvoices/InvoiceDetail/PrintInvoice'
import { DashboardEmployeeRoot } from './containers/Dashboard/DashboardEmployees'
import { DashboardEmployees } from './containers/Dashboard/DashboardEmployees/DashboardEmployees'
import { DashboardSecurityRoles } from './containers/Dashboard/DashboardEmployees/DashboardSecurityRoles'
import { AddEmployee } from './containers/Dashboard/DashboardEmployees/AddEmployee'
import { DashboardSuppliers } from './containers/Dashboard/DashboardSuppliers'
import { DashboardLicensedProducers } from './containers/Dashboard/DashboardLicencedProducers'
import { AddProduct } from './containers/Dashboard/DashboardProducts/AddProduct'
import { AddCategoryModal } from './containers/Dashboard/DashboardProducts/AddCategoryModal'
import { ReportView } from './containers/Dashboard/DashboardReports/Financial'
import { SalesSummary } from './containers/Dashboard/DashboardReports/Financial/ReportView/SalesSummary'
import { FinancialReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/FinancialReport'
import { PaymentTypesReport as PaymentTypesReportV1 } from './containers/Dashboard/DashboardReports/Financial/ReportView/PaymentTypes/v1/PaymentTypesReport'
import { AdvancedPaymentTypesReport } from './containers/Dashboard/DashboardReports/Advanced/AdvancedSalesPaymentTypesReport'
import { GrowthReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/GrowthReport'
import { SalesByDayAndHourReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/SalesByDayAndHourReport'
import { ProductSalesReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/ProductSalesReportV2'
import { ProductSalesOverTimeReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/ProductSalesOverTimeReport'
import { InventoryOnHandReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/InventoryOnHandReport'
import { CategoriesReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/CategoriesReport'
import { CategorySalesOverTimeReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/CategorySalesOverTimeReport'
import { VendorsReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/VendorsReport'
import { DiscountsReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/DiscountsReport'
import { RestockReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/RestockReport/RestockReport'
import { TransfersBreakdown } from './containers/Dashboard/DashboardReports/Financial/ReportView/TransfersBreakdown'
import { PurchaseOrderReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/PurchaseOrderReport'
import { CustomersReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/CustomersReport'
import { EmployeeReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/EmployeeReport'
import { EmployeeHoursReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/EmployeeHoursReport'
import { InventorySummaryReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/InventorySummaryReport/InventorySummaryReport'
import { InventoryLogs } from './containers/Dashboard/DashboardReports/InventoryLogs'
import { Compliance } from './containers/Dashboard/DashboardReports/Compliance'
import Insights from './containers/Dashboard/DashboardReports/Insights/Insights'

import { EditAudit } from './containers/Dashboard/DashboardInventory/AuditV2/EditAudit'
import { EditTransfer } from './containers/Dashboard/DashboardInventory/BulkTransfer/EditTransfer/EditTransferV2'
import { ShiftsPage } from './containers/Dashboard/DashboardReports/Shifts'
import { DashboardWooCommerce } from './containers/Dashboard/DashboardIntegrations/WooCommerce'
import { WooCommerceProducts } from './containers/Dashboard/DashboardIntegrations/WooCommerce/WordpressProducts'
import { WooCommerceCategories } from './containers/Dashboard/DashboardIntegrations/WooCommerce/WordpressCategories'
import { WooCommerceSettings } from './containers/Dashboard/DashboardIntegrations/WooCommerce/WordpressSettings'
import { PrintingConfigView } from './containers/Dashboard/Printing'
import { DashboardQuickBooks } from './containers/Dashboard/DashboardIntegrations/QuickBooks'
import { QuickBooksAuthCallback } from './containers/Dashboard/DashboardIntegrations/QuickBooks/QuickBooksAuthCallback'
import { QuickBooksAuthConnect } from './containers/Dashboard/DashboardIntegrations/QuickBooks/QuickBooksAuthConnect'
import { QuickBooksMain } from './containers/Dashboard/DashboardIntegrations/QuickBooks/QuickBooksMain/index'
import { QuickBooksSettings } from './containers/Dashboard/DashboardIntegrations/QuickBooks/QuickBooksMain/QuickBooksSettings/index'
import { QuickBooksSync } from './containers/Dashboard/DashboardIntegrations/QuickBooks/QuickBooksMain/QuickBooksSync/index'
import { Receipts } from './containers/Dashboard/DashboardSettings/Receipts'
import { InventorySettings } from './containers/Dashboard/DashboardSettings/InventorySettings'
import { GiftCardReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/GiftCardReport'
import { GiftCardSettings } from './containers/Dashboard/DashboardSettings/GiftCards/GiftCardSettings'
import { PaymentSettings } from './containers/Dashboard/DashboardSettings/Payments/PaymentSettings'
import { Integrations } from './containers/Dashboard/DashboardIntegrations'
import { InvoiceDetail } from './containers/Dashboard/DashboardInvoices/InvoiceDetail'
import { SourcesReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/SourcesReport'
import { DashboardBrands } from './containers/Dashboard/DashboardBrands'
import { DashboardWeedmaps } from './containers/Dashboard/DashboardIntegrations/Weedmaps'
import { SalesTrendsReport } from './containers/Dashboard/DashboardReports/Financial/ReportView/SalesTrends/SalesTrendsReport'
import { DashboardOutreach } from './containers/Dashboard/DashboardCustomersV2/Outreach'
import { DashboardOCSComplianceSettings } from './containers/Dashboard/DashboardCompliance/OCSComplianceSettings'
import { DataReconciliation } from './containers/Dashboard/DashboardCompliance/OCSComplianceDataReconciliation'
import { InventoryCorrections } from './containers/Dashboard/DashboardCompliance/InventoryCorrections/InventoryCorrections'
import { ProcessOnDateLogs } from './containers/Dashboard/DashboardCompliance/ProcessOnDateLogs/ProcessOnDateLogs'
import { SampleDirect } from './containers/Dashboard/DashboardProducts/SampleDirect/SampleDirect'
import { ComplianceIssues } from './containers/Dashboard/DashboardCompliance/OCSComplianceIssues'
import Broadcasts from './containers/Dashboard/DashboardReports/Insights/broadcasts'

export default [
  <Route key='dashboard-routes' path='dashboard' component={Dashboard}>
    <IndexRedirect to='home' />
    <Redirect from='setup' to='home' />
    <Route path='home' component={DashboardHome} />
    <Redirect from='settings' to='settings/general' />
    <Route path='settings' component={DashboardSettingsRoot}>
      <Route path='general' component={General} />
      <Route path='locations' component={Locations} />
      <Route path='pos' component={POSDevices} />
      <Route path='receipts' component={Receipts} />
      <Route path='taxes' component={TaxSettings} />
      <Route path='digitalSignage' component={DigitalSignageSettings} />
      <Route path='inventory' component={InventorySettings} />
      <Route path='giftcards' component={GiftCardSettings} />
      <Route path='payments' component={PaymentSettings} />
      <Route path='loyalty' component={LoyaltyContainer} />
    </Route>
    <Route path='integrations' component={Integrations} />
    <Route path='integrations/weedmaps' component={DashboardWeedmaps} />
    <Redirect from='integrations/wooCommerce' to='integrations/wooCommerce/products' />
    <Route path='integrations/wooCommerce' component={DashboardWooCommerce}>
      <Route path='products' component={WooCommerceProducts} />
      <Route path='categories' component={WooCommerceCategories} />
      <Route path='settings' component={WooCommerceSettings} />
    </Route>

    <Route path='integrations/quickBooks' component={DashboardQuickBooks}>
      <Route path='authConnect' component={QuickBooksAuthConnect} />
      <Route path='authCallback' component={QuickBooksAuthCallback} />

      <Route path='main' component={QuickBooksMain}>
        <Route path='settings' component={QuickBooksSettings} />
        <Route path='sync' component={QuickBooksSync} />
      </Route>
    </Route>

    <Route path='products' component={DashboardProducts}>
      <IndexRedirect to='productListing' />
      {/* If you're reading this in the future, you can remove the redirects - Sam: 05/02/2020 */}
      <Route path='productListing' component={ProductListing} />
      <Redirect from='v3/productListing' to='productListing' />
      <Route path='productListing/editProduct/:productId' component={AddProduct} />
      <Redirect
        from='v3/productListing/editProduct/:productId'
        to='productListing/editProduct/:productId'
      />
      <Route path='productListing/addProduct' component={AddProduct} />
      <Redirect from='v3/productListing/addProduct' to='productListing/addProduct' />
      <Route path='pricingGroups' component={PricingGroups} />
      <Route path='suppliers' component={DashboardSuppliers} />
      <Route path='licensedProducers' component={DashboardLicensedProducers} />
      <Route path='brands' component={DashboardBrands} />
      <Route path='categories' component={ProductCategories}>
        <Route path='addCategory' component={AddCategoryModal} />
        <Route path='add-category' component={AddCategoryModal} />
      </Route>
      <Route path='discounts' component={Discounts} />
      <Route path='discounts/addDiscount' component={AddDiscount} />
      <Route path='discounts/editDiscount/:discountId' component={AddDiscount} />
      <Route path='sample-direct' component={SampleDirect} />
    </Route>
    <Route path='inventory' component={DashboardInventory}>
      <IndexRedirect to='overview' />
      <Redirect from='update' to='overview' />
      <Route path='overview' component={DashboardViewInventory} />
      <Route path='update/snapshots' component={InventorySnapshots} />
      <Route path='update/snapshots/:inventorySnapshotId' component={ViewInventorySnapshot} />
      <Route path='transfer' component={DashboardTransfer} />
      <Route path='transfer/editTransfer' component={EditTransfer} />
      <Route path='transfer/editTransfer/:transferId' component={EditTransfer} />
      <Route path='convert' component={Conversion} />
      <Route path='audit' component={Audit} />
      <Route path='audit/:auditId' component={EditAudit} />
      <Route path='alerts' component={StockAlerts} />
    </Route>
    <Redirect from='customers' to='customers/list' />
    <Route path='customers/list' component={DashboardCustomers} />
    <Route path='customers/loyalty' component={Loyalty} />
    <Route path='customers/outreach' component={DashboardOutreach} />
    <Route path='sales'>
      <IndexRedirect to='list' />
      <Route path='list' component={SalesList} />
      <Route path='parkedSales' component={ParkedSales} />
      <Route path='orderHub' component={ParkedSales} />
    </Route>

    <Route path='purchaseOrders' component={DashboardInvoices} />
    <Route
      path='purchaseOrders/editPurchaseOrder/:purchaseOrderId/print'
      component={PrintInvoice}
    />

    <Route path='purchaseOrders/editPurchaseOrder' component={InvoiceDetail} />
    <Route path='purchaseOrders/editPurchaseOrder/:purchaseOrderId' component={InvoiceDetail} />

    <Route path='employees/addEmployee' component={AddEmployee} />
    <Route path='employees' component={DashboardEmployeeRoot}>
      <IndexRedirect to='employees' />
      <Route path='employees' component={DashboardEmployees} />
      <Route path='securityRoles' component={DashboardSecurityRoles} />
    </Route>
    <Redirect from='reports' to='reports/analytics' />
    <Redirect from='reports/financial' to='reports/analytics/summary' />
    <Redirect from='reports/analytics' to='reports/analytics/summary' />
    <Route path='reports/analytics' component={ReportView}>
      <Route path='summary' component={SalesSummary} />
      <Route path='financials' component={FinancialReport} />
      <Route path='paymentTypes' component={PaymentTypesReportV1} />
      <Route path='sales-trends' component={SalesTrendsReport} />
      <Route path='growth' component={GrowthReport} />
      <Route path='salesByDayAndHour' component={SalesByDayAndHourReport} />
      <Route path='productsOverview' component={ProductSalesReport} />
      <Route path='productsOverTime' component={ProductSalesOverTimeReport} />
      <Route path='categoriesOverview' component={CategoriesReport} />
      <Route path='categoriesOverTime' component={CategorySalesOverTimeReport} />
      <Route path='vendors' component={VendorsReport} />
      <Route path='sources' component={SourcesReport} />
      <Route path='discounts' component={DiscountsReport} />
      <Route path='inventory-on-hand' component={InventoryOnHandReport} />
      <Route path='inventorySummary' component={InventorySummaryReport} />
      <Route path='restock' component={RestockReport} />
      <Route path='transfers' component={TransfersBreakdown} />
      <Route path='purchaseOrders' component={PurchaseOrderReport} />
      <Route path='customers' component={CustomersReport} />
      <Route path='employeeSales' component={EmployeeReport} />
      <Route path='employeeHours' component={EmployeeHoursReport} />
      <Route path='giftCards' component={GiftCardReport} />
    </Route>
    <Redirect from='reports/financial/:reportView' to='reports/analytics/:reportView' />
    <Route path='reports/analytics/:reportView' component={ReportView} />
    <Route path='reports/inventoryLogs' component={InventoryLogs} />
    <Route path='reports/compliance' component={Compliance} />
    <Route path='reports/insights' component={Insights} />
    <Route path='reports/insights/:reportId' component={Insights} />
    <Route path='reports/broadcasts/list' component={Broadcasts} />
    <Route path='reports/shifts' component={ShiftsPage} />
    <Route path='print' component={PrintingConfigView} />
    <Route path='compliance'>
      <Route path='settings' component={DashboardOCSComplianceSettings} />
      <Route path='issues' component={ComplianceIssues} />
      <Route path='data-reconciliation' component={DataReconciliation} />
      <Route path='inventory-corrections' component={InventoryCorrections} />
      <Route path='process-on-date-logs' component={ProcessOnDateLogs} />
    </Route>
    <Route path='ecommerce'>
      <Route path='settings' component={EcommerceSettings} />
    </Route>
  </Route>,
]
